export var connectedSocialAccount = {
  cursor: '13',
  node: {
    createdAt: '2022-12-22T16:32:14.523684Z',
    description: '<a href=/profiles/58efcb38-6bf3-4d2e-a624-f61c1fddf2d3?action=edit>Manage your social connections</a>',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/twitter_connected-8f287f8b9c.png',
    id: '13720',
    title: 'Twitter Account Connected',
    unread: false,
    eventType: 'twitter_connected',
    node: null
  }
};
export var likedPublicResponseNotification = {
  cursor: '12',
  node: {
    createdAt: '2022-12-16T22:30:48.692612Z',
    // eslint-disable-next-line no-useless-escape
    description: "<p>Maddy Test456 liked your response to <a target=\"_parent\" href=\"https://rewrite-test.influitives.com/challenges/986\">yakub public challenge 2022 dec 7</a>: <q class=\"truncate_3_lines\"><em><p>How are you?</p>: I'm great<br>\n<p>upload image</p>: <a class=\"embedded-link\" target=\"_blank\" href=\"https://static.influitive.com/files/images/1cwmEeGTZ69TB2U54PI8_Pumpkin-pie-recipe.jpeg\">https://static.influitive.com/files/images/1cwmEeGTZ69TB2U54PI8_Pumpkin-pie-recipe.jpeg</a><br>\n<p>upload video</p>: <a class=\"embedded-link\" target=\"_blank\" href=\"https://static.influitive.com/files/raw/ekRcqCLQeqhCkNCoSww4_rewards-page.mp4\">https://static.influitive.com/files/raw/ekRcqCLQeqhCkNCoSww4_rewards-page.mp4</a><br>\n<p>upload a file</p>: <a class=\"embedded-link\" target=\"_blank\" href=\"https://cdn.filestackcontent.com/eKzfNoRvSQKcNryOIJzc#landlady.pdf\">https://cdn.filestackcontent.com/eKzfNoRvSQKcNryOIJzc#landlady.pdf</a></em></q></p>",
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/like-ebb8afefe7.png',
    id: '13473',
    title: 'Liked',
    unread: true,
    eventType: 'like',
    node: null
  }
};
export var commentedOnPublicResponseNotification = {
  cursor: '11',
  node: {
    createdAt: '2022-12-16T22:30:53.392639Z',
    description: 'Alice Advocateman commented on your response to <a target="_parent" href="https://rewrite-test.influitives.com/challenges/968">Public Responses Challenge X</a> challenge: <em>vhfv</em>',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/comment-a71d0addb5.png',
    id: '13474',
    title: 'Alice Advocateman commented on your Challenge response',
    unread: false,
    eventType: 'comment',
    node: null
  }
};
export var perkNotification = {
  cursor: '10',
  node: {
    createdAt: new Date().toISOString(),
    description: "<p>Congratulations! You've been gifted 'S'well' by Melissa Meyer. Click to redeem</p>",
    iconUrl: null,
    id: '1',
    title: 'Your 10th notification',
    unread: true,
    eventType: 'reward_available',
    node: null
  }
};
export var levelUpNotification = {
  cursor: '9',
  node: {
    createdAt: new Date().toISOString(),
    description: "<p>Congratulations! You've levelled up! You're now an Influivian in Training.</p>",
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '2',
    title: 'Your 9th notification',
    unread: true,
    eventType: 'advanced_level',
    node: null
  }
};
export var notifications = [levelUpNotification, perkNotification, {
  cursor: '1',
  node: {
    createdAt: '2021-08-12T07:20:50.52Z',
    description: '1rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '10',
    title: 'Your 1st notification',
    unread: true,
    eventType: 'corporate_confirmation',
    node: {
      __typename: 'Challenge',
      id: 'challenge id'
    }
  }
}, {
  cursor: '2',
  node: {
    createdAt: '2020-10-12T07:20:50.52Z',
    description: '2rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '9',
    title: 'Your 2nd notification',
    unread: true,
    eventType: 'twitter_connected',
    node: null
  }
}, {
  cursor: '3',
  node: {
    createdAt: '2019-10-12T07:20:50.52Z',
    description: '3rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '8',
    title: 'Your 3rd notification',
    unread: false,
    eventType: 'linkedin_connected',
    node: null
  }
}, {
  cursor: '4',
  node: {
    createdAt: '2018-10-12T07:20:50.52Z',
    description: '4rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '7',
    title: 'Your 4rd notification',
    unread: false,
    eventType: 'apple_connected',
    node: null
  }
}, {
  cursor: '5',
  node: {
    createdAt: '2017-10-12T07:20:50.52Z',
    description: '5rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '6',
    title: 'Your 5rd notification',
    unread: false,
    eventType: 'facebook_connected',
    node: null
  }
}, {
  cursor: '6',
  node: {
    createdAt: '2016-10-12T07:20:50.52Z',
    description: '6rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '5',
    title: 'Your 6rd notification',
    unread: false,
    eventType: 'challenge_completed',
    node: null
  }
}, {
  cursor: '7',
  node: {
    createdAt: '2015-10-12T07:20:50.52Z',
    description: '7rd notification',
    iconUrl: 'https://static.influitive.com/influitiveimages/hq/attachments/original/2726.?1620332613',
    id: '4',
    title: 'Your 7rd notification',
    unread: false,
    eventType: 'redemption_requested',
    node: null
  }
}, {
  cursor: '8',
  node: {
    createdAt: '2014-10-12T07:20:50.52Z',
    description: '8rd notification',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '3',
    title: 'Your 8rd notification',
    unread: false,
    eventType: 'corporate_redo',
    node: null
  }
}, commentedOnPublicResponseNotification, likedPublicResponseNotification, connectedSocialAccount, {
  cursor: '14',
  node: {
    createdAt: '2014-10-12T07:20:50.52Z',
    description: 'MemberA commented on your response to <a target="_parent" href="https://advocate-app.infldev.com/challenges/23">Challenge Name</a> challenge: <em>Great pic!</em>',
    iconUrl: 'https://static.influitive.com/hub-fe/images/event_types/completed_challenge-2d39683b97.png',
    id: '14',
    title: 'MemberA commented on your Challenge response',
    unread: false,
    eventType: 'comment',
    node: {
      __typename: 'PublicResponseComment',
      id: '1',
      publicResponse: {
        __typename: 'PublicResponse',
        id: '2',
        stage: {
          id: 'a',
          challenge: {
            id: 'a',
            activities: [{
              id: 'a',
              state: 'closed'
            }]
          }
        }
      }
    }
  }
}, {
  cursor: '15',
  node: {
    createdAt: '2023-06-09T14:18:28.677927Z',
    description: '<p>MemberA liked your response to <a target="_parent" href="https://rewrite-test.influitives.com/challenges/1166">ADVO2-2398 test</a>: </p><div class="truncate_3_lines"><em>So great</em></div>',
    iconUrl: 'https://images.influitive.com/cdn-cgi/imagedelivery/pKRqk_cgZfGOj9FgBNYyVA/event_types_like/public',
    id: '17351',
    title: 'Liked',
    unread: false,
    eventType: 'like',
    node: {
      __typename: 'PublicResponseComment',
      id: '1',
      publicResponse: {
        __typename: 'PublicResponse',
        id: '2',
        stage: {
          id: 'a',
          challenge: {
            id: 'a',
            activities: [{
              id: 'a',
              state: 'closed'
            }]
          }
        }
      }
    }
  }
}, {
  cursor: '15',
  node: {
    createdAt: '2023-06-09T14:17:42.590026Z',
    description: '<p>MemberA liked your response to <a target="_parent" href="https://rewrite-test.influitives.com/challenges/1166">ADVO2-2398 test</a>: </p><div class="truncate_3_lines"><em><p><strong><em><u>Watch one of the 8-10 minute sessions and share one key takeaway<span class="fr-emoticon fr-deletable">😀</span> </u></em></strong></p>: Great</em></div>',
    iconUrl: 'https://images.influitive.com/cdn-cgi/imagedelivery/pKRqk_cgZfGOj9FgBNYyVA/event_types_like/public',
    id: '17350',
    title: 'Liked',
    unread: false,
    eventType: 'like',
    node: {
      __typename: 'PublicResponse',
      id: '1',
      stage: {
        id: 'a',
        challenge: {
          id: 'a',
          activities: [{
            id: 'a',
            state: 'closed'
          }]
        }
      }
    }
  }
}];